// src/i18n/es/hotels.js
const hotels = {
    name: 'Hotel |||| Hoteles',
    title: 'Gestión de Hoteles',
    status_active: 'Activo',
    status_inactive: 'Inactivo',
    titles: {
        list: 'Hoteles',
        create: 'Nuevo Hotel',
        edit: 'Editar Hotel',
        show: 'Detalles del Hotel',
    },
    fields: {
        id: 'ID',
        name: 'Nombre',
        group: 'Grupo',
        groupId: 'Grupo',
        groupName: 'Grupo',
        address: 'Dirección',
        city: 'Ciudad',
        country: 'País',
        postalCode: 'Código Postal',
        phone: 'Teléfono',
        email: 'Email',
        defaultLanguage: 'Idioma por defecto',
        installationCode: 'Código de instalación',
        isActive: 'Activo',
        settings: 'Configuración',
        zones: 'Zonas',
        lockerCount: 'Total de taquillas',
        userCount: 'Usuarios',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
        users: 'Usuarios',
        lockers: 'Taquillas',
        status: 'Estado',
        operationMode: 'Modo de Operación',
        allowMultipleLockers: 'Permitir múltiples taquillas por asignación',

        // Reference fields and tag types
        title: 'Campos de Referencia',
        reference_fields: 'Campos de Referencia',
        supported_tag_types: 'Tipos de ID Soportados',
        no_reference_fields: 'No hay campos de referencia configurados. Haz clic en "Añadir" para crear uno.',
        no_tag_types_available: 'No hay tipos de ID disponibles. Contacta al administrador del sistema.',
        
        // Field form
        add_field: 'Añadir Campo',
        edit_field: 'Editar Campo',
        delete_field: 'Eliminar Campo',
        delete_field_confirm: '¿Estás seguro de que quieres eliminar el campo "{label}" ({key})?',
        delete_warning: 'Esta acción no se puede deshacer.',
        
        field_key: 'Clave del Campo',
        field_key_help: 'Identificador único (ej: "room_number", "guest_name")',
        field_label: 'Etiqueta',
        field_label_help: 'Texto que verán los usuarios',
        field_mandatory: 'Campo Obligatorio',
        field_order: 'Orden de Visualización',
        field_order_help: 'Los números más bajos aparecen primero',
        
        // Messages
        field_saved: 'Campo guardado correctamente',
        field_deleted: 'Campo eliminado correctamente',
        configuration_saved: 'Configuración guardada correctamente',
        error_saving: 'Error al guardar la configuración',
        field_key_required: 'La clave y etiqueta del campo son obligatorias',
        field_key_unique: 'La clave del campo debe ser única',
        
        // Tag types
        tag_type_system: 'Sistema',
        tag_type_manual: 'Manual',
        select_tag_types: 'Selecciona los tipos de ID que el hotel puede usar',
        
        // Branding fields
        primary_color: 'Color Principal',
        logo: 'Logo',
        
        // Custom texts fields
        language: 'Idioma',
        custom_texts: 'Textos Personalizados',
        text_key: 'Clave del Texto',
        text_value: 'Valor del Texto',
        
        // Additional HotelFields translations
        count: '%{current} de %{max} campos configurados',
        subtitle: 'Configura hasta 5 campos personalizados para información adicional',
        no_fields: 'No hay campos configurados',
        no_fields_description: 'Los campos de referencia permiten capturar información adicional personalizada',
        create_first_field: 'Crear primer campo',
        new_field: 'Nuevo campo',
        mandatory: 'Obligatorio',
        key: 'Clave',
        display_order: 'Orden de visualización',
        move_up: 'Mover arriba',
        move_down: 'Mover abajo',
        edit: 'Editar',
        delete: 'Eliminar',
        cancel: 'Cancelar',
        create: 'Crear',
        update: 'Actualizar',
        saving: 'Guardando...',
        deleting: 'Eliminando...',
        saved_success: 'Campos guardados con éxito',
        save_error: 'Error al guardar los campos',
        save_changes: 'Guardar cambios',
        load_error: 'Error al cargar los campos',
        label_required: 'El nombre del campo es obligatorio',
        key_required: 'La clave del campo es obligatoria',
        key_format_error: 'La clave debe empezar con letra minúscula y solo contener letras minúsculas, números y guiones bajos',
        key_exists: 'Ya existe un campo con esa clave',
        label_helper: 'Nombre visible para los usuarios',
        key_helper: 'Identificador único (solo minúsculas, números y guiones bajos)',
        max_fields_warning: 'No se pueden agregar más de 5 campos',
        max_fields_reached: 'Has alcanzado el límite máximo de 5 campos de referencia',
        unsaved_changes: 'Tienes cambios sin guardar',
        delete_confirm: '¿Estás seguro de que quieres eliminar el campo \'%{name}\'?',
        no_permissions_delete: 'No tienes permisos para eliminar campos',
    },
    
    alert_config: {
        // Page header
        page_title: 'Configuración de Notificaciones',
        title: 'Configuración de Alertas',
        subtitle: 'Gestiona los destinatarios y el nivel de severidad de las alertas del sistema',
        email_service_title: 'Servicio de Email',
        email_service_subtitle: 'Configura la integración con el servicio de notificaciones',

        // Status messages
        setup_required: 'Configura el servicio de email para habilitar el envío de notificaciones',
        service_active: 'El servicio de email está configurado y funcionando correctamente',
        connection_untested: 'El servicio está configurado. Prueba la conexión para verificar que funciona correctamente',

        // Severity levels
        debug: 'Debug',
        info: 'Información',
        warning: 'Advertencia',
        error: 'Error',
        critical: 'Crítico',

        // Form labels
        min_severity_label: 'Nivel Mínimo de Severidad',
        min_severity_help: 'Solo se enviarán notificaciones para alertas con este nivel de severidad o superior',
        recipients_title: 'Destinatarios de Alertas',
        email_label: 'Email',
        email_placeholder: 'ejemplo@email.com',
        api_key_label: 'API Key',
        account_name_label: 'Nombre de cuenta',
        account_name_placeholder: 'Nombre de la cuenta en Roommatik Notify',
        template_title: 'Plantilla del email de envío de código QR',
        template_label: 'Plantilla de Email',
        template_placeholder: 'Selecciona una plantilla',

        // Connection status
        connected: 'Conectado',
        no_connection: 'Sin conexión',
        untested: 'No probado',

        // Actions
        add: 'Agregar',
        save_config: 'Guardar Cambios',
        saving: 'Guardando...',
        update_api_key: 'Actualizar API Key',
        config_api_key: 'Configurar API Key',
        test_connection: 'Probar Conexión',
        testing: 'Probando...',
        continue_editing: 'Continuar editando',
        exit_without_saving: 'Salir sin guardar',
        loading: 'Cargando...',

        // Messages
        no_recipients: 'No hay destinatarios configurados. Agrega emails para recibir alertas del sistema.',
        email_required: 'Ingresa un email',
        email_invalid: 'Email inválido',
        email_exists: 'Este email ya está en la lista',
        api_key_current_placeholder: '••••••••',
        api_key_placeholder: 'Ingresa la API Key',
        api_key_keep_help: 'Deja vacío para mantener la configuración actual',
        api_key_required_help: 'Requerido para habilitar el envío de emails',
        connection_warning: 'La API Key está guardada pero no se pudo verificar la conexión. Los emails no se enviarán hasta que se establezca una conexión válida.',
        unsaved_indicator: 'Tienes cambios sin guardar',

        // Success/Error messages
        load_error: 'Error al cargar la configuración',
        save_success: 'Configuración guardada correctamente',
        save_error: 'Error al guardar la configuración',
        connection_success: 'Conexión exitosa',
        connection_failed: 'No se pudo conectar. Verifica tu API Key',
        connection_test_error: 'Error al probar conexión',
        api_key_saved: 'API Key guardada con éxito',
        connection_verified: 'Conexión verificada correctamente',
        api_key_saved_no_connection: 'API Key guardada pero sin conexión activa',
        api_key_save_error: 'Error al guardar API Key',
        template_updated: 'Plantilla actualizada con éxito',
        template_update_error: 'Error al actualizar plantilla',
        hotel_load_error: 'No se pudo cargar la información del hotel',

        // Dialog
        unsaved_changes_title: 'Cambios sin guardar',
        unsaved_changes_message: 'Los cambios realizados se perderán si sales sin guardar',
        unsaved_changes_question: '¿Deseas salir sin guardar los cambios?',
    },
    filters: {
        search: 'Buscar',
        search_placeholder: 'Nombre, dirección o código...',
        group: 'Grupo',
        all_groups: 'Todos los grupos',
        active_only: 'Solo activos',
        inactive_only: 'Solo inactivos',
        country: 'País',
        all_countries: 'Todos los países',
    },
    actions: {
        create: 'Nuevo Hotel',
        edit: 'Editar',
        edit_desc: 'Modificar información básica',
        delete: 'Eliminar',
        delete_desc: 'Eliminar permanentemente',
        activate: 'Activar',
        deactivate: 'Desactivar',
        manage_zones: 'Gestionar Zonas',
        manage_zones_desc: 'Configurar áreas del hotel',
        manage_texts: 'Textos HMI',
        manage_texts_desc: 'Personalización multiidioma',
        manage_notifications: 'Notificaciones',
        manage_notifications_desc: 'Alertas y reportes',
        manage_fields: 'Campos de Referencia',
        manage_fields_desc: 'Tipos de identificación',
        manage_pms: 'Integración PMS',
        manage_pms_desc: 'Sistema de gestión hotelera',
        manage_guest_access: 'Acceso de Huéspedes',
        manage_guest_access_desc: 'Métodos de acceso a taquillas',
        view_statistics: 'Ver estadísticas',
        view_stats: 'Ver Estadísticas',
        disable: 'Desactivar',
        configure: 'Configurar',
        configure_desc: 'Operación, zonas, personalización y más',
        upload_logo: 'Subir Logo',
        add_text: 'Añadir Texto',
        add_language: 'Añadir Idioma',
        delete_language: 'Eliminar idioma',
        deleting: 'Eliminando...',
        export_data: 'Exportar datos',
        export: 'Exportar',
        import: 'Importar',
        export_csv_hint: 'Para editar en Excel o Google Sheets',
        export_json_hint: 'Para respaldo o uso técnico',
        import_texts: 'Importar textos desde archivo CSV o JSON',
        export_texts: 'Exportar todos los idiomas',
        
        // New actions from HotelTexts.tsx
        back_to_config: 'Volver a configuración',
        change_logo: 'Cambiar',
        remove: 'Eliminar',
        saving: 'Guardando...',
        save_branding: 'Guardar Identidad',
        save_texts: 'Guardar textos',
        add_first_text: 'Añadir primer texto',
        delete_text: 'Eliminar texto',
        continue_editing: 'Continuar editando',
        exit_without_saving: 'Salir sin guardar',
        change_language: 'Cambiar idioma',
        checking: 'Verificando...',
        add_default_texts: 'Añadir textos por defecto',
    },
    messages: {
        no_hotels: 'No hay hoteles registrados',
        no_hotels_hint: 'Comienza creando tu primer hotel',
        loading: 'Cargando hoteles...',
        create_success: 'Hotel creado correctamente',
        update_success: 'Hotel actualizado correctamente',
        delete_success: 'Hotel eliminado correctamente',
        delete_confirm: '¿Está seguro de que desea eliminar este hotel?',
        activate_success: 'Hotel activado correctamente',
        deactivate_success: 'Hotel desactivado correctamente',
        installation_code_copied: 'Código de instalación copiado',
        access_denied: 'No tienes permisos para ver los hoteles.',
        unsaved_changes: 'Tienes cambios sin guardar',
        default_texts_added: 'Textos por defecto añadidos',
        texts_already_exist: 'Los textos ya existen',
        texts_exported: 'Textos exportados',
        texts_imported: 'Textos importados correctamente',
        language_deleted: 'Idioma eliminado correctamente',
        no_texts_configured: 'No hay textos configurados. Puedes cargar los textos por defecto.',
        no_texts_hint: 'No hay textos configurados. Puedes cargar los textos por defecto o añadir textos personalizados.',
    },
    validation: {
        name_required: 'El nombre del hotel es obligatorio',
        name_min_length: 'El nombre debe tener al menos 3 caracteres',
        name_max_length: 'El nombre no puede exceder 100 caracteres',
        name_exists: 'Ya existe un hotel con este nombre',
        address_max_length: 'La dirección no puede exceder 255 caracteres',
        installation_code_required: 'El código de instalación no puede estar vacío',
        installation_code_max_length: 'El código de instalación no puede exceder 50 caracteres',
        installation_code_exists: 'Ya existe un hotel con este código de instalación',
        invalid_language: 'Idioma no válido',
        group_required: 'Debe seleccionar un grupo',
        email_format: 'El formato del email no es válido',
        phone_format: 'El formato del teléfono no es válido',
        installation_code_format: 'El código de instalación no es válido',
        email_duration: 'Debe estar entre 1 y 168 horas',
        code_expiration: 'Debe estar entre 5 y 1440 minutos',
        locker_hold: 'Debe estar entre 5 y 120 minutos',
        email_duration_required: 'La duración del email es obligatoria',
        email_duration_range: 'Debe estar entre 1 y 168 horas',
        code_expiration_required: 'La expiración del código es obligatoria',
        code_expiration_range: 'Debe estar entre 5 y 1440 minutos',
    },
    dialogs: {
        delete_title: 'Eliminar Hotel',
        delete_message: '¿Está seguro de que desea eliminar el hotel %{name}?',
        delete_warning: 'Esta acción eliminará todas las zonas, taquillas y asignaciones asociadas.',
        delete_cascade_warning: 'Esta acción eliminará todas las zonas, taquillas y asignaciones asociadas.',
        deactivate_title: 'Desactivar Hotel',
        deactivate_message: '¿Está seguro de que desea desactivar el hotel %{name}?',
        add_text_title: 'Añadir Texto Personalizado',
        
        // New dialogs from HotelTexts.tsx
        add_language_title: 'Añadir Nuevo Idioma',
        delete_language_title: 'Eliminar Idioma',
        delete_language_message: 'Se eliminarán todos los textos del idioma seleccionado. Esta acción no se puede deshacer.',
        unsaved_changes_title: 'Cambios sin guardar',
        unsaved_changes_warning: 'Los cambios realizados se perderán si sales sin guardar',
        unsaved_both: 'Tienes cambios sin guardar tanto en los textos como en la identidad visual.',
        unsaved_texts: 'Tienes cambios sin guardar en los textos personalizados.',
        unsaved_branding: 'Tienes cambios sin guardar en la identidad visual.',
        confirm_exit: '¿Estás seguro de que deseas salir?',
        unsaved_language_warning: 'Tienes cambios sin guardar en el idioma actual',
        change_language_title: 'Cambiar idioma',
        change_language_message: 'Si cambias de idioma, perderás los cambios realizados en los textos del idioma %{selectedLanguage}. ¿Deseas continuar?',
    },
    tabs: {
        general: 'General',
        operation: 'Operación',
        zones: 'Zonas',
        customization: 'Personalización',
        notifications: 'Notificaciones',
        page_subtitle: 'Configuración del hotel',
        // Legacy
        configuration: 'Configuración',
        lockers: 'Taquillas',
        statistics: 'Estadísticas',
        settings: 'Ajustes',
    },
    settings: {
        title: 'Configuración del Hotel',
        notifications: {
            title: 'Notificaciones',
            email: 'Email de notificaciones',
            types: 'Tipos de notificaciones',
        },
        locker_settings: {
            title: 'Configuración de Taquillas',
            auto_release_hours: 'Horas para liberación automática',
            allow_multiple: 'Permitir asignaciones múltiples',
            require_guest_info: 'Requerir información del huésped',
        },
        customization: {
            title: 'Personalización',
            logo: 'Logo del hotel',
            primary_color: 'Color primario',
            secondary_color: 'Color secundario',
        },
    },
    status: {
        active: 'Activo',
        inactive: 'Inactivo',
    },
    sections: {
        basic_info: 'Información Básica',
        basic_info_subtitle: 'Datos principales del hotel',
        basic_info_create_subtitle: 'Datos principales del nuevo hotel',
        operation_mode: 'Modo de Operación',
        operation_mode_subtitle: 'Configuración del sistema de acceso',
        timing_config: 'Configuración de Tiempos',
        tag_types: 'Tipos de ID Soportados',
        tag_types_subtitle: 'Tipos de identificación que acepta este hotel',
        branding: 'Identidad Visual',
        branding_subtitle: 'Personaliza el logo y color principal del hotel',
        custom_texts: 'Textos Personalizados',
        custom_texts_subtitle: 'Personaliza los textos de la interfaz en múltiples idiomas',
    },
    help: {
        name: 'Nombre único que identifica al hotel',
        group: 'Grupo al que pertenece el hotel',
        address: 'Dirección física del hotel',
        installationCode: 'Formato: TAyy1234',
        defaultLanguage: 'Idioma por defecto para las interfaces del hotel',
        select_tag_types: 'Selecciona los tipos de ID que el hotel puede usar para el acceso a las taquillas',
        operationMode: 'Modo de funcionamiento del sistema de taquillas',
        emailAssignmentDuration: 'Tiempo de validez de las asignaciones por email',
        codeExpiration: 'Tiempo de expiración de los códigos de acceso',
        lockerHold: 'Tiempo máximo que una taquilla puede estar reservada sin ser usada',
        allowMultipleLockers: 'Cuando está desactivado, cada asignación obtiene exactamente una taquilla (compatible con el HMI actual)',
        primary_color: 'Color principal utilizado en la interfaz del huésped',
        logo: 'Logo que se mostrará en las interfaces del hotel (formato PNG/JPG)',
        text_key: 'Formato: categoria.nombre_texto (ej: button.submit)',
    },
    notes: {
        after_create: 'Después de crear el hotel, podrás configurar zonas, asignar taquillas y gestionar usuarios.',
    },
    placeholders: {
        select_group: 'Seleccionar grupo',
        name: 'Ingrese el nombre del hotel',
        address: 'Ingrese la dirección del hotel',
        installationCode: 'TAyy1234',
        search_texts: 'Buscar textos...',
    },
    labels: {
        no_group: 'Sin grupo',
    },
    select_group: 'Seleccionar grupo',
    no_groups: ' ',
    notifications: {
        created: 'Hotel creado con éxito',
        deleted: 'Hotel eliminado con éxito',
        load_config_error: 'Error al cargar la configuración del hotel',
        tag_selection_required: 'Debe seleccionar al menos un tipo de ID para el modo Tag Only',
        general_config_updated: 'Configuración general actualizada con éxito',
        hotel_updated: 'Hotel actualizado con éxito',
        texts_saved: 'Textos guardados con éxito',
        texts_save_error: 'Error al guardar los textos',
        brand_config_saved: 'Configuración de marca guardada con éxito',
        brand_config_error: 'Error al guardar la configuración de marca',
        text_key_empty: 'La clave del texto no puede estar vacía',
        text_key_exists: 'Esta clave ya existe',
        select_image_file: 'Por favor selecciona un archivo de imagen',
        file_size_limit: 'El archivo no debe superar los 2MB',
        fields_config_load_error: 'Error al cargar la configuración de campos',
        reference_fields_updated: 'Campos de referencia actualizados con éxito',
        reference_fields_save_error: 'Error al guardar los campos de referencia',
        max_fields_exceeded: 'No se pueden agregar más de 5 campos de referencia',
        field_name_required: 'El nombre del campo es obligatorio',
        field_key_required: 'La clave del campo es obligatoria',
        field_key_format_error: 'La clave debe empezar con letra minúscula y solo contener letras minúsculas, números y guiones bajos',
        field_key_exists: 'Ya existe un campo con esa clave',
        no_delete_permission: 'No tienes permisos para eliminar campos',
        notifications_config_load_error: 'Error al cargar la configuración de notificaciones',
        notifications_config_saved: 'Configuración de notificaciones guardada con éxito',
        notifications_config_save_error: 'Error al guardar la configuración',
        unsaved_changes: 'Cambios sin guardar',
        language_deleted: 'Idioma eliminado correctamente',
        default_texts_added: 'Textos por defecto añadidos',
        texts_already_exist: 'Los textos ya existen',
        texts_exported: 'Textos exportados',
        texts_imported: 'Textos importados correctamente',
    },
    
    // New sections from HotelTexts.tsx
    empty: {
        no_results: 'No se encontraron textos que coincidan con "%{searchText}"',
        no_texts: 'No hay textos configurados para este idioma',
    },
    
    info: {
        showing_filtered: 'Mostrando %{filteredCount} de %{totalCount} textos',
        total_texts: '%{count} textos configurados',
        texts_configured: 'textos configurados',
    },
    
    alerts: {
        tag_required: 'Se requiere una etiqueta',
    },
    
    errors: {
        create: 'Error al crear el hotel',
        ensure_texts_failed: 'Error al asegurar textos por defecto',
        load_groups: 'Error al cargar los grupos',
        export_failed: 'Error al exportar los textos',
        import_failed: 'Error al importar los textos',
        invalid_import_format: 'Formato de archivo no válido',
    },
    languages: {
        spanish: 'Español',
        english: 'English',
        french: 'Français',
        german: 'Deutsch',
        italian: 'Italiano',
        portuguese: 'Português',
    },
    zones: {
        title: 'Gestión de Zonas',
        subtitle: 'Organiza las taquillas en diferentes áreas del hotel',
        count: '%{count} zona configurada |||| %{count} zonas configuradas',
        new_zone: 'Nueva Zona',
        edit_zone: 'Editar Zona',
        delete_zone: 'Eliminar Zona',
        zone_name: 'Nombre de la Zona',
        description: 'Descripción',
        order: 'Orden',
        order_help: 'Orden en que aparecerá la zona',
        cancel: 'Cancelar',
        create: 'Crear',
        update: 'Actualizar',
        saving: 'Guardando...',
        creating: 'Creando...',
        updating: 'Actualizando...',
        deleting: 'Eliminando...',
        delete_confirm: '¿Estás seguro de que quieres eliminar la zona %{name}?',
        delete_warning: 'Esta zona tiene %{count} taquillas asociadas. Eliminar la zona también eliminará estas asociaciones.',
        edit: 'Editar',
        delete: 'Eliminar',
        name_required: 'El nombre de la zona es obligatorio',
        name_exists: 'Ya existe una zona con ese nombre',
        created_success: 'Zona creada con éxito',
        updated_success: 'Zona actualizada con éxito',
        deleted_success: 'Zona eliminada con éxito',
        create_error: 'Error al crear la zona',
        update_error: 'Error al actualizar la zona',
        delete_error: 'Error al eliminar la zona',
        load_error: 'Error al cargar las zonas del hotel',
        no_permissions_create: 'No tienes permisos para crear zonas',
        no_permissions_edit: 'No tienes permisos para editar zonas',
        no_permissions_delete: 'No tienes permisos para eliminar zonas',
        no_permissions_save: 'No tienes permisos para guardar zonas',
        invalid_hotel_id: 'ID de hotel no válido',
        hotel_load_error: 'Error al cargar la información del hotel',
        no_zones: 'No hay zonas configuradas',
        no_zones_description: 'Las zonas te permiten organizar las taquillas por áreas del hotel',
        create_first_zone: 'Crear primera zona',
        no_description: 'Sin descripción',
        add: 'Añadir Zona',
        empty: 'No hay zonas configuradas. Las zonas permiten organizar las taquillas por áreas del hotel.',
        create_title: 'Nueva Zona',
        edit_title: 'Editar Zona',
        name: 'Nombre de la zona',
        lockers: 'Taquillas',
        name_helper: 'Nombre identificativo de la zona (ej: Recepción, Piscina)',
        description_helper: 'Descripción opcional de la zona',
        // Operating schedule
        operating_schedule: 'Horario de funcionamiento',
        schedule_enabled: 'Horario activado',
        schedule_enabled_help: 'Si está desactivado, la zona funciona 24/7',
        off_hours_behavior: 'Comportamiento fuera de horario',
        full_lockout: 'Bloqueo total',
        full_lockout_desc: 'No se permite ningún acceso',
        access_only: 'Solo acceso existente',
        access_only_desc: 'Los huéspedes con taquilla asignada pueden acceder, pero no se asignan nuevas',
        day_monday: 'Lunes',
        day_tuesday: 'Martes',
        day_wednesday: 'Miércoles',
        day_thursday: 'Jueves',
        day_friday: 'Viernes',
        day_saturday: 'Sábado',
        day_sunday: 'Domingo',
        day_open: 'Abierto',
        time_open: 'Apertura',
        time_close: 'Cierre',
        copy_to_all: 'Copiar a todos',
        weekdays_same: 'Laborables iguales',
        day_closed: 'Cerrado',
        schedule_saved: 'Horario guardado correctamente',
        schedule_save_error: 'Error al guardar el horario',
        schedule_load_error: 'Error al cargar el horario',
    },
    operation: {
        // Header
        title: 'Flujo de Operación',
        subtitle: 'Configure cómo los huéspedes acceden a las taquillas',

        // Validation
        validation_one_method: 'Debe habilitar al menos un método de acceso',
        saved: 'Configuración de operación guardada',
        save_all: 'Guardar Configuración',

        // Mode selector
        mode_title: 'Modo de Operación',
        mode_description: 'Seleccione cómo funciona el sistema de acceso a taquillas para este hotel',
        mode_TAG_ONLY: 'Solo Tags',
        mode_EMAIL_BASED: 'Basado en Email',
        mode_PMS_INTEGRATED: 'Integración PMS',
        mode_TAG_ONLY_desc: 'Acceso mediante tags físicos o códigos del backoffice. Sin solicitudes automáticas.',
        mode_EMAIL_BASED_desc: 'El huésped solicita un código introduciendo su email en el HMI. También acepta tags y QR.',
        mode_PMS_INTEGRATED_desc: 'Validación de reservas en tiempo real con el PMS. Requiere conexión PMS configurada.',
        mode_TAG_ONLY_help: 'Los huéspedes acceden usando tags físicos (tarjetas, pulseras) o códigos generados desde el backoffice. No hay solicitudes automáticas. Ideal para spas, gimnasios o áreas con control directo del personal.',
        mode_EMAIL_BASED_help: 'Los huéspedes pueden solicitar un código de acceso introduciendo su email en el HMI. El sistema genera y envía un código automáticamente. También acepta tags y QR. Ideal para autoservicio sin integración PMS.',
        mode_PMS_INTEGRATED_help: 'El sistema se conecta con el PMS del hotel para validar reservas en tiempo real. Los huéspedes pueden usar su número de reserva, RFID de la habitación o email vinculado. Requiere una conexión PMS configurada.',

        // PMS Connection
        pms_connection: 'Conexión PMS',
        pms_test: 'Probar',
        pms_configure: 'Configurar PMS',
        pms_warning: 'La validación PMS está activada pero no hay conexión PMS configurada. Los huéspedes no podrán acceder si la validación PMS es obligatoria.',
        pms_not_configured: 'No hay conexión PMS configurada. Configure una para habilitar la validación de reservas.',
        confirm_delete_pms: '¿Está seguro de eliminar la configuración PMS?',
        pms_deleted: 'Conexión PMS eliminada',
        pms_sync_providers: 'Sincronizar Proveedores',
        pms_providers_synced: 'Proveedores PMS sincronizados',
        pms_active: 'Activa',
        pms_inactive: 'Inactiva',
        pms_last_test_success: 'Última prueba: exitosa',
        pms_last_test_failed: 'Última prueba: fallida',
        pms_edit_saved_values_info: 'Se muestran los valores guardados. Por seguridad, las credenciales no se muestran: deje el campo vacío para conservar la actual o introduzca una nueva para sustituirla.',
        pms_secret_saved_helper: 'Valor guardado. Déjelo vacío para conservarlo.',

        // Access Methods
        access_methods: 'Métodos de Acceso',
        access_methods_tooltip: 'Configure qué métodos pueden usar los huéspedes para acceder a las taquillas desde el HMI',
        access_methods_desc: 'Seleccione los métodos que los huéspedes podrán usar en la pantalla del HMI',
        method_email: 'Código por Email',
        method_email_desc: 'El huésped introduce su email y recibe un código de acceso',
        email_validation: 'Validar email contra reservas',
        email_validation_tooltip: 'Si activado: Solo emails con reserva activa reciben código (más seguro). Si desactivado: Cualquier email puede solicitar código (más permisivo).',
        email_validation_on: 'Más seguro: Solo huéspedes con reserva confirmada',
        email_validation_off: 'Más permisivo: Cualquier email puede solicitar código',
        method_qr: 'Código QR',
        method_qr_desc: 'El huésped escanea el código QR recibido por email o generado en el backoffice',
        method_rfid: 'Tarjeta RFID',
        method_rfid_desc: 'El huésped escanea su tarjeta o pulsera RFID en el HMI',
        method_reservation: 'Número de Reserva',
        method_reservation_desc: 'El huésped introduce su número de reserva y opcionalmente su apellido',

        // PMS Validation
        pms_validation_title: 'Validación con PMS',
        pms_validation_tooltip: 'Configure cómo se valida el acceso contra el sistema de gestión hotelera (PMS)',
        pms_validation_desc: 'Determine cuándo y cómo se verifica la reserva del huésped con el PMS',
        pms_failover_title: '¿Qué pasa cuando el PMS no responde?',
        failover_optional_allow: 'Modo Opcional + Failsafe ON: Si el PMS falla, se permite acceso con datos locales. El servicio nunca se interrumpe.',
        failover_optional_deny: 'Modo Opcional + Failsafe OFF: Si el PMS falla, se deniega el acceso. Esto funciona como modo requerido en la práctica.',
        failover_required_allow: 'Modo Requerido + Failsafe ON: Si el PMS está caído, se permite acceso temporal. Balance entre seguridad y disponibilidad.',
        failover_required_deny: 'Modo Requerido + Failsafe OFF: Si el PMS falla, se deniega el acceso. Máxima seguridad pero el servicio se interrumpe si hay problemas con el PMS.',
        pms_missing_warning: 'La validación PMS está activada pero no hay una conexión PMS configurada. Configure una conexión PMS arriba para que la validación funcione correctamente.',
        pms_mode_label: 'Modo de Validación PMS',
        pms_mode_help: 'Determina cuándo se valida la reserva del huésped contra el sistema PMS',
        failsafe_label: 'Permitir acceso si el PMS no responde (failsafe)',
        failsafe_tooltip: 'Cuando activado, permite acceso temporal si el PMS está caído. Cuando desactivado, deniega el acceso si hay problemas con el PMS.',

        // Timing & Codes
        timing_title: 'Tiempos y Códigos',
        timing_desc: 'Configure los parámetros temporales y de seguridad de los códigos de acceso',
        email_duration: 'Duración de asignación por email (horas)',
        email_duration_help: 'Tiempo que permanece activa una asignación por email (1-168h)',
        code_expiration: 'Expiración del código (minutos)',
        code_expiration_help: 'Minutos para usar el código después de generado (5-1440)',
        locker_hold: 'Tiempo de reserva de taquilla (minutos)',
        locker_hold_help: 'Minutos que permanece reservada una taquilla sin confirmar (5-120)',
        access_code_expiration: 'Validez del código de acceso (horas)',
        access_code_expiration_help: 'Horas que un código de acceso permanece válido (1-168h = hasta 7 días)',
        code_length: 'Longitud del código',
        code_length_help: 'Número de caracteres alfanuméricos (4-12). Recomendado: 6',

        // Locker Assignment Mode
        assignment_mode_title: 'Modo de asignación de taquillas',
        assignment_mode_help: 'Configure cuántas taquillas puede recibir cada asignación',

        // RFID Configuration
        rfid_title: 'Configuración RFID',
        rfid_tooltip: 'Configure cómo el sistema interpreta y procesa las tarjetas o pulseras RFID',
        rfid_desc: 'Determine cómo se extrae o valida la información del tag RFID',
        rfid_behavior: 'Comportamiento RFID',
        rfid_pattern: 'Patrón de Extracción (Regex)',
        rfid_pattern_help: 'Expresión regular para extraer el número de habitación. Ej: "ROOM-(\\d+)" extrae "301" de "ROOM-301"',

        // Validation Requirements
        validation_title: 'Requisitos de Validación',
        validation_desc: 'Información adicional requerida para autenticar al huésped',
        require_surname: 'Requerir apellido del huésped',
        require_surname_tooltip: 'Aplica cuando el huésped usa "Número de Reserva". El sistema pedirá el número de reserva Y el apellido.',
        require_surname_help: 'Autenticación de dos factores: Número de reserva + Apellido',
        send_confirmation: 'Enviar código por email tras validar reserva',
        send_confirmation_tooltip: 'Cuando el huésped usa "Número de Reserva", solicitar su email para enviarle el código como recordatorio.',

        // Mock PMS Info
        mock_pms_tooltip: 'Ver datos de prueba Mock PMS',
        mock_pms_title: 'Datos de prueba - Mock PMS',
        mock_pms_description: 'Los adaptadores mock aceptan cualquier valor en los campos de configuración (api_key, hotel_code, etc.).',
        mock_pms_invalid_hint: 'Use "invalid" en el campo password para simular un fallo de autenticación.',
        mock_rest_title: 'Mock REST - Reservas de prueba:',
        mock_soap_title: 'Mock SOAP - Reservas de prueba:',
        mock_table_locator: 'Localizador',
        mock_table_guest: 'Huésped',
        mock_table_room: 'Hab.',
        mock_table_status: 'Estado',
        mock_table_result: 'Resultado',
        mock_result_success_precheckin: 'Éxito (pre-checkin)',
        mock_result_success_postcheckout: 'Éxito (post-checkout)',
        mock_result_rejected_inhouse: 'Rechazado (ya alojado)',
        mock_result_rejected_future: 'Rechazado (reserva futura)',
        mock_result_rejected_past: 'Rechazado (checkout pasado)',
        mock_validation_info: 'Los estados PRE_CHECKIN y POST_CHECKOUT permiten validación exitosa. IN_HOUSE, RESERVED y CHECKED_OUT son rechazados.',
    },
    operation_modes: {
        title: 'Modo de Operación',
        subtitle: 'Define cómo los huéspedes acceden a las taquillas',
        tag_only: 'Solo Tags',
        tag_only_description: 'Los huéspedes acceden usando tags físicos (tarjetas, pulseras) o códigos generados desde el backoffice. No hay solicitudes automáticas. Ideal para spas, gimnasios o áreas con control directo del personal.',
        email_based: 'Basado en Email',
        email_based_description: 'Los huéspedes pueden solicitar un código de acceso desde la pantalla del HMI introduciendo su email. El sistema genera y envía un código automáticamente. También acepta tags y códigos QR. Ideal para autoservicio sin integración PMS.',
        pms_integrated: 'Integración PMS',
        pms_integrated_description: 'El sistema se conecta con el PMS del hotel para validar reservas en tiempo real. Los huéspedes pueden usar su número de reserva, RFID de la habitación o email vinculado. Requiere conexión PMS configurada.',
        save_success: 'Configuración de operación guardada',
        save_error: 'Error al guardar la configuración de operación',
        pms_connection: 'Conexión PMS',
        pms_connection_subtitle: 'Estado de la integración con el sistema de gestión hotelera',
        pms_not_configured: 'No hay conexión PMS configurada',
        pms_warning: 'El modo PMS Integrado requiere una conexión PMS activa. Configure la conexión para que este modo funcione correctamente.',
        pms_validation_warning: 'La validación PMS está habilitada pero no hay conexión PMS configurada. Los huéspedes no podrán validarse hasta que se configure.',
        access_methods: 'Métodos de Acceso',
        access_methods_subtitle: 'Cómo los huéspedes pueden acceder a las taquillas',
        pms_validation: 'Validación PMS',
        pms_validation_subtitle: 'Verificar la reserva del huésped con el PMS',
        timing_config: 'Tiempos y Códigos',
        timing_config_subtitle: 'Configuración de duración y expiración',
        rfid_config: 'Configuración RFID',
        rfid_config_subtitle: 'Comportamiento de las tarjetas RFID',
        validation_requirements: 'Requisitos de Validación',
        validation_requirements_subtitle: 'Datos adicionales requeridos al huésped',
    },
    config: {
        general_saved: 'Configuración general guardada',
    },
};

export default hotels;